<template>
  <div>
    <div v-if="embededMode" :style="$parent.getHeaderStyles()">
      <div
        class="close-btn arrow-back"
        @click="$parent.goPreStep()"
        style="color:#fff;"
      ></div>
    </div>
    <div class="row" v-show="!this.embededMode">
      <div class="col-xs-12 col-xl-12 px-0">
        <h3>Your reservation requirements</h3>
      </div>
    </div>
    <div
      class="row"
      :class="isMobile() ? 'mb-4' : ''"
      v-show="
        this.configurationInfo.showVenue ||
          this.configurationInfo.showBookingType
      "
    >
      <div class="right-column">
        <div class="row" v-show="this.configurationInfo.showVenue">
          <label>Venue</label>
          <select
            v-if="reservationItems.venues && reservationItems.venues.length > 1"
            v-model="reservationInfo.venue"
            class="form-control rounded-0"
            @change="venueChanged(reservationInfo.venue)"
          >
            <option
              v-for="ven in reservationItems.venues"
              :value="ven.Company_ID"
              :key="ven.Company_ID"
              >{{ ven.DisplayName }}</option
            >
          </select>

          <span
            class="form-control rounded-0 venue-name"
            @load="venueChanged(reservationInfo.venue)"
            v-else-if="reservationItems.venues.length == 1"
            >{{ reservationItems.venues[0].DisplayName }}</span
          >
          <br />
        </div>
        <div class="row" style="margin-top: 22px !important;">
          <label>{{
            reservationInfo.venueInfo &&
            reservationInfo.venueInfo.GuestLabelOverride
              ? reservationInfo.venueInfo.GuestLabelOverride
              : "Guests"
          }}</label>
          <select
            id="number-of-guests"
            v-model="reservationInfo.numberOfGuests"
            @change="populateTimes()"
            class="form-control rounded-0"
          >
            <option
              v-for="(num, index) in reservationItems.numberOfGuests"
              :key="index"
              :value="num"
              >{{ `${num}` }}</option
            >
          </select>
          <br />
          <p
            v-if="$parent.hasPayment() && $parent.isDepositPerGeust()"
            class="deposit-payment"
          >
            Deposit applies:
            <strong
              >${{
                fix2digit(reservationInfo.venueInfo.DepositPerGuest)
              }}</strong
            >
            &nbsp;per
            {{
              reservationInfo.venueInfo &&
              reservationInfo.venueInfo.GuestLabelOverride
                ? reservationInfo.venueInfo.GuestLabelOverride
                : "person"
            }}
            ( Total: <strong>${{ $parent.paymentValue() }}</strong
            >&nbsp;)
          </p>
          <p
            v-if="$parent.hasPayment() && !$parent.isDepositPerGeust()"
            class="deposit-payment"
          >
            Deposit Applies:
            <strong>${{ $parent.paymentValue() }}</strong>
            &nbsp;for reservation
          </p>
        </div>
        <div id="date" class="row" style="margin-top: 22px !important;">
          <label>Date</label>
          <div>
            <datepicker
              v-if="loaded"
              bootstrap-styling
              @opened="pickerOpen()"
              :disabledDates="getDisabledDates()"
              v-model="reservationInfo.date"
              @input="dateChanged(reservationInfo.date)"
              :inline="true"
              @changedMonth="updatedatepicker"
              :calendar-class="iscurrentmonth ? 'hideprev' : ''"
            ></datepicker>
          </div>
          <br />
        </div>
      </div>

      <div class="left-column">
        <div class="row" v-show="showReservationType">
          <label>Reservation Type</label>

          <select
            id="booking-types-list"
            v-model="reservationInfo.bookingType"
            class="form-control"
            :class="isMobile() ? '' : 'rounded-left'"
            @change="validate()"
          >
            <option
              v-for="(bookingType, index) in reservationItems.bookingTypes"
              :key="index"
              :value="bookingType"
              >{{ bookingType }}</option
            >
          </select>
        </div>
        <p v-if="timeslotsError" class="time-error-message">
          {{ timeslotsError }}
        </p>
        <div class="row btn-group" v-if="showTimeSlots">
          <div class="time-scrolling">
            <span
              :key="index"
              :class="
                reservationItems.times.length > 2
                  ? 'button-container'
                  : 'btn-group'
              "
              v-for="(time, index) in this.reservationItems.times"
            >
              <button
                v-if="time == reservationInfo.exactTime"
                :value="time"
                type="button"
                class="btn btn-selected"
                @click="setTime(time)"
                :style="configurationInfo.Styles.btn"
              >
                {{ time }}
              </button>
              <button
                v-else-if="reservationItems.times.indexOf(time) != -1"
                :value="time"
                type="button"
                class="btn"
                @click="setTime(time)"
              >
                {{ time }}
              </button>
              <button
                v-else
                disabled="disabled"
                type="button"
                class="btn"
                :value="time"
                @click="setTime(time)"
              >
                {{ time }}
              </button>
            </span>
          </div>
        </div>
        <loading
          :active="
            reservationItems.times.length == 0 &&
              !showloading &&
              !timeslotsError
          "
          :can-cancel="false"
          :is-full-page="false"
        ></loading>
      </div>
    </div>
    <div class="row"></div>
    <loading
      :active.sync="showloading"
      :can-cancel="false"
      :is-full-page="false"
    ></loading>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import { DetectMobile } from "./../../helpers/ui/detectmobile";
import { setDatePickerMargin } from "../../helpers/ui/uiHelper";
import { DateTime } from "luxon";
import { getAvailableDays } from "../../services/reservationService";
import { dateHelper } from "../../helpers/dateHelper/dateHelper";
import { getAvailableTimes } from "../../services/reservationService";
import { wcconfig } from "../../../wcConfig.js";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: {
    Datepicker,
    Loading,
  },
  data() {
    return {
      availabledays: [],
      loaded: false,
      pickerClass: "",
      firstavailabledate: null,
      monthsessions: [],
      disabledate: [],
      showloading: false,
      url: "",
      msg: "",
      iscurrentmonth: true,
      lastSelectedTime: "",
    };
  },
  props: {
    sid: {
      type: String,
      default: "",
    },
    reservationInfo: {
      type: Object,
      default: function() {
        return {
          venue: 0,
          bookingType: "",
          numberOfGuests: 1,
          date: "",
          time: "",
          TimezoneIanaFormat: "",
          exactTime: "",
        };
      },
    },
    embededMode: {
      type: Boolean,
      default: false,
    },
    disabledDates: {
      type: Object,
    },
    configurationInfo: {
      type: Object,
      default: function() {
        return {
          showDeposit: false,
          minimumDepositPerGuest: 0,
          currency: "$",
          wizardIndex: 0,
          singlePage: false,
          showVenue: true,
          showBookingType: true,
          defaultDate: "",
          defaultTime: "",
          defaultGuest: "",
          theme: "",
        };
      },
    },
    reservationItems: {
      type: Object,
      default: function() {
        return {
          venues: [],
          bookingTypes: [],
          numberOfGuests: [],
          dates: [],
          times: [],
          stores: [],
          availableTimes: [],
          availableSeats: [],
          aroundTimes: [],
        };
      },
    },
    timeslotsError: {
      type: String,
      required: false,
      default: null,
    },
  },
  computed: {
    showReservationType() {
      return (
        this.configurationInfo.showBookingType &&
        this.reservationItems.bookingTypes &&
        this.reservationItems.bookingTypes.length >= 1
      );
    },
    showTimeSlots() {
      return (
        this.reservationItems.times && this.reservationItems.times.length > 0
      );
    },
  },
  watch: {
    showTimeSlots(newVal, oldVal) {
      if (newVal && !oldVal && this.lastSelectedTime) {
        if (this.reservationItems.times.indexOf(this.lastSelectedTime) != -1) {
          this.setTime(this.lastSelectedTime);
        }
      } else if (oldVal && !newVal) {
        if (typeof this.reservationInfo.date != "number") {
          this.lastSelectedTime = this.reservationInfo.exactTime;
        }
      }
    },
  },
  mounted() {
    this.url = wcconfig.assets.ajaxIndicator;
    this.pickerOpen();
    this.updatedatepicker(new Date());
  },
  methods: {
    changemonth(ev) {
      var getdate = new Date(ev);
    },
    updatedatepicker(month) {
      if (month.timestamp) month = new Date(month.timestamp);

      this.disabledate = [];
      this.reservationItems.times = [];
      this.showloading = true;

      var nowdate = new Date();

      nowdate.getMonth() == month.getMonth() &&
      nowdate.getFullYear() == month.getFullYear()
        ? (this.iscurrentmonth = true)
        : (this.iscurrentmonth = false);

      var that = this;
      getAvailableDays(this.sid, month).then((day) => {
        that.availabledays = day.data.validDays;
        that.monthsessions = day.data.monthseassions;
        that.firstavailabledate = null;
        that.monthsessions.forEach((item) => {
          var splitDate = item.day.split("-");
          if (splitDate[0].length == 1) splitDate[0] = "0".concat(splitDate[0]);

          if (splitDate[1].length == 1) splitDate[1] = "0".concat(splitDate[1]);

          item.day = splitDate.join("-");
          var avTimes = new Array();
          var avSeats = new Array();
          item.session.forEach((subitem) => {
            avTimes.push(subitem.startTime);
            avSeats.push(subitem.available);
          });
          var populateResult = that.$parent.populateTimes(
            avTimes,
            avSeats,
            1,
            "",
            item.day
          );
          if (!populateResult) {
            that.disabledate.push(item.day);
          } else {
            if (that.firstavailabledate == null)
              that.firstavailabledate = item.day;
          }
        });
        if (that.firstavailabledate != null) {
          var res = that.firstavailabledate.split("-");
          var newdate = res[2] + "-" + res[1] + "-" + res[0];
          that.reservationInfo.date = Date.parse(newdate);
          that.dateChanged(that.reservationInfo.date);
        }

        that.loaded = true;
        that.showloading = false;
      });
    },
    pickerOpen() {
      setDatePickerMargin();
    },
    isDateBlackedOut(input) {
      if (
        !this.reservationInfo ||
        !this.reservationInfo.venueInfo ||
        !Array.isArray(this.reservationInfo.venueInfo.BlackoutDates)
      ) {
        return false;
      } else {
        const { BlackoutDates } = this.reservationInfo.venueInfo;
        const parsedBlackoutDates = BlackoutDates.filter((map) => {
          return typeof map === "object" && typeof map.Date === "string";
        }).map((map) => {
          return map.Date.split("-");
        });
        const [inputDate, inputMonth, inputYear] = input.split("-");

        return !!parsedBlackoutDates.find(([year, month, date]) => {
          return (
            parseInt(year) == parseInt(inputYear) &&
            parseInt(month) == parseInt(inputMonth) &&
            parseInt(date) == parseInt(inputDate)
          );
        });
      }
    },
    getDisabledDates() {
      var that = this;
      return {
        customPredictor: function(date) {
          var datetime = new Date(DateTime.local().minus({ day: 1 }));
          if (date < datetime) return true;
          var dayNumber = date.getDay();
          const dateString =
            date.getDate() > 9
              ? date.getDate().toString()
              : "0".concat(date.getDate());
          const month = date.getMonth() + 1;
          const monthString = month > 9 ? month.toString() : "0".concat(month);

          const checkdate = dateString.concat(
            "-",
            monthString,
            "-",
            date.getFullYear()
          );
          if (that.isDateBlackedOut(checkdate)) return true;
          if (that.disabledate.includes(checkdate)) return true;
          if (!that.availabledays.includes(dayNumber)) return true;
          else return false;
        },
      };
    },
    setTime(time) {
      let that = this;
      that.reservationInfo.exactTime = time;
      this.$parent.validate();
    },
    populateAroundTimes() {
      this.$parent.populateAroundTimes();
      this.$parent.validate();
    },
    populateTimes() {
      let that = this;
      this.$parent.getTimes(
        that.reservationInfo.venue,
        that.reservationInfo.date,
        that.reservationInfo.numberOfGuests
      );
      this.$parent.validate();
    },
    dateChanged(date) {
      setDatePickerMargin();
      this.$parent.dateChanged(date);
    },
    venueChanged(ven) {
      this.$parent.venueChanged(ven);
      this.$parent.validate();
    },
    validate() {
      this.$parent.validate();
    },
    fix2digit(value) {
      return parseFloat(value).toFixed(2);
    },
    isMobile() {
      return DetectMobile.methods.isMobile();
    },
  },
};
</script>
